import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import DefaultCPButton from './defaultCommandPanelButton';

function DeleteButton({ content, onClick, disabled }) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faTimes} />}
      color="error"
    />
  );
}

DeleteButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

DeleteButton.defaultProps = {
  content: 'Видалити',
  disabled: false,
};

export default DeleteButton;
